import { RootState } from '.'
// app state selector
export const selectAppState = (state: RootState) => state.app

// User selectors
export const selectCurrentUser = (state: RootState) => state.user.currentUser
export const selectIsUserLoading = (state: RootState) => state.user.isLoading
export const selectUserError = (state: RootState) => state.user.error

// user info selector
export const selectUserUserId = (state: RootState) => state.user.currentUser?.uuid
export const selectUserUuid = (state: RootState) => state.user.currentUser?.uuid
export const selectUserNickname = (state: RootState) => state.user.currentUser?.nickname
export const selectUserLoginName = (state: RootState) => state.user.currentUser?.loginName
export const selectUserSteamId = (state: RootState) => state.user.currentUser?.steamId
export const selectUserSteamTradeUrl = (state: RootState) => state.user.currentUser?.steamTradeUrl
export const selectUserAvatar = (state: RootState) => state.user.currentUser?.avatar
export const selectUserInviterId = (state: RootState) => state.user.currentUser?.inviterId
export const selectUserLevelAttrs = (state: RootState) => state.user.levelAttrs
export const selectUserEmail = (state: RootState) => state.user.currentUser?.email

// user bullet balance selector
export const selectBalance = (state: RootState) => state.balance.total
export const selectIsBalanceLoading = (state: RootState) => state.balance.isLoading
export const selectBalanceError = (state: RootState) => state.balance.error
export const selectIsRefreshBalance = (state: RootState) => state.app.isRefreshBalance

// user skins length selector
export const selectUserSkinsLength = (state: RootState) => state.user.userSkinsLength
export const selectUserFreeCaseNum = (state: RootState) => state.user.userFreeCaseNum

// user skins total value selector
export const selectSkinTotal = (state: RootState) => state.skinTotal.total
export const selectIsSkinTotalLoading = (state: RootState) => state.skinTotal.isLoading
export const selectSkinTotalError = (state: RootState) => state.skinTotal.error

// app refresh vip info selector
export const selectIsRefreshVipInfo = (state: RootState) => state.app.isRefreshVipInfo

// app refresh skin total selector
export const selectIsRefreshSkinTotal = (state: RootState) => state.app.isRefreshSkinTotal

// app is opening box selector
export const selectIsOpeningBox = (state: RootState) => state.app.isOpeningBox

// app is re charge success selector
export const selectIsReChargeSuccess = (state: RootState) => state.app.isReChargeSuccess

// app is open my skins modal selector
export const selectIsOpenMySkinsModal = (state: RootState) => state.app.isOpenMySkinsModal

// app is open trade url selector
export const selectIsOpenTradeUrl = (state: RootState) => state.app.isOpenTradeUrl

// open box animation controller selector
export const selectSkipAnimation = (state: RootState) =>
  state.openBoxAnimationController.skipAnimation
